import { useMemo, useState } from 'react'

import { BACKEND_DATE_FORMAT } from 'config/Vars'
import moment from 'moment'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'

import type Employee from 'modules/employees/store/models/Employee'
import { LeaveTypes } from 'modules/timeoff/store/collections/leaveTypes'
import type LeaveType from 'modules/timeoff/store/models/LeaveType'

interface Props {
  employee: Employee | null | undefined
  loadingLeave: boolean
  showEmployeeSelector: boolean
  leaveTypeId: number | null | undefined
  active?: boolean
}
interface ReturnType {
  leaveTypes: LeaveTypes
  selectedLeaveType: LeaveType | undefined
}
interface PayloadType {
  active?: boolean
  leave_type_id?: number | null | undefined
  employee_id?: number | null | undefined
  reference_date?: string
}

const useFetchLeaveTypes = ({
  employee,
  showEmployeeSelector,
  loadingLeave,
  leaveTypeId,
  active,
}: Props): ReturnType => {
  const leaveTypes = useMemo<LeaveTypes>(() => new LeaveTypes([]), [])
  const [selectedLeaveType, setSelectedLeaveType] = useState<LeaveType | undefined>()

  const formattedReferenceDate = moment().format(BACKEND_DATE_FORMAT)

  useAsyncData(async () => {
    if (loadingLeave) return

    let data: PayloadType = {}

    if (active) data = { ...data, active }

    if (!showEmployeeSelector) {
      if (!!leaveTypeId) data = { ...data, leave_type_id: leaveTypeId }
      if (employee)
        data = {
          ...data,
          employee_id: employee.attributes.id,
          reference_date: formattedReferenceDate,
        }
    }

    await leaveTypes.fetch({ data })

    const urlLeaveType = leaveTypes.find({
      id: leaveTypeId,
    })
    setSelectedLeaveType(urlLeaveType || leaveTypes.models[0])
  }, [leaveTypeId, loadingLeave, showEmployeeSelector, formattedReferenceDate])

  return {
    leaveTypes,
    selectedLeaveType,
  }
}

export default useFetchLeaveTypes
